import React, { useMemo } from 'react';
import { Table } from 'antd';
import FeeActions from './FeeActions';
import { normalizeFees } from '../../../../../utills/fee-normalizer';

const FeeTable = ({ groupName, feeList, onEdit, onDelete }) => {
  const normalizedFees = useMemo(() => normalizeFees(feeList), [feeList]);
  const columns = [

    {
      title: groupName,
      dataIndex: 'name',
      key: 'name',
      render: (text, record) =>
        record.name || record.displayName || record.category_name || record.category || '-',
    },
    ,
    {
      title: 'Moeda',
      dataIndex: 'currency',
      key: 'currency',
      width: 80,
    },
    {
      title: 'Valor',
      dataIndex: 'value',
      key: 'value',
      width: 120,
      render: (value, record, index) => (
        <span>
          {record.currency} {Number(value).toLocaleString('en-US', { minimumFractionDigits: 2 })}
        </span>
      ),
    },
    {
      title: 'Ações',
      key: 'actions',
      width: 100,
      render: (_, record, index) => (
        <FeeActions
          onEdit={() => onEdit(groupName, index, record)}
          onDelete={() => onDelete(groupName, index)}
        />
      ),
    },
  ];
  return (
    <Table
      dataSource={normalizedFees}
      columns={columns}
      pagination={false}
      size="small"
      rowKey={(record, index) => `${groupName}-${index}`}
      bordered
    />
  );
};

export default FeeTable;